import { createCombineMapItem } from '../../../../../reducerRegistry';

import { createReduceObject as createObjectCollectionReduceObject } from '../../../../../common/reducers/objectCollection/reducer';

import contestsCollectionSaga from './sagas/contestsCollectionSaga';

export default [
  ...createCombineMapItem(
    'contestsCollection',
    createObjectCollectionReduceObject,
    [contestsCollectionSaga]
  )
];



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/contests/reducers/static/collections/reducersMap.js